export const practiceFilterMappings: Record<string, string> = {
  Market: 'marketIds',
  marketIds: 'marketIds',
  States: 'states',
  q: 'q', // Search query mapping
  'Minimum Age': 'minAge',
  'Maximum Age': 'maxAge',
  'Takes Walkins': 'takesWalkIns',
  'New Telehealth': 'newTelehealth',
  Suffix: 'suffix',
  Specialty: 'specialty',
  Title: 'title',
  'Other Languages': 'otherLanguages',
  'ADD/ADHD': 'addAdhd',
  'Chronic Pain Management': 'chronicPainManagement',
  PAP: 'pap',
  'New Patient': 'newPatient',
  'Flu Shots': 'fluShots',
  'Unvaccinated Children': 'unvaccinatedChildren',
  'OB Visits': 'obVisits',
  'Workers Comp': 'workersComp',
  'Disability Physical': 'disabilityPhysical',
  'Military Physical': 'militaryPhysical',
  'Flight Physical': 'flightPhysical',
  'DOT Physical': 'dotPhysical',
  'Immigration Physical': 'immigrationPhysical',
};